import { render } from "./DocumentEditor.vue?vue&type=template&id=ae3eff30&scoped=true"
import script from "./DocumentEditor.vue?vue&type=script&lang=js"
export * from "./DocumentEditor.vue?vue&type=script&lang=js"

import "./DocumentEditor.vue?vue&type=style&index=0&id=ae3eff30&lang=css"
import "./DocumentEditor.vue?vue&type=style&index=1&id=ae3eff30&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3eff30"]])

export default __exports__